const Breakpoints = {
  S: '560px', // > 560px = phones portrait
  M: '880px', // > 880px = phones landscape / tablets portrait
  L: '1040px', // > 1040px = tablets landscape / large tablets portrait
  XL: '1280px', // > 1280px = large tablets portrait / notebooks / desktops
  XXL: '1600px', // > 1600px = large notebooks / large desktops
};

export function addDesktopListener(onViewportChange) {
  addBreakpointListener(Breakpoints.M, onViewportChange);
}

export function isDesktop() {
  return window.matchMedia(`(min-width: ${Breakpoints.M})`).matches;
}

function addBreakpointListener(breakpoint, onViewportChange) {
  const mediaQueryList = window.matchMedia(`(min-width: ${breakpoint})`);
  onViewportChange(mediaQueryList.matches);
  mediaQueryList.addEventListener('change', ({ matches }) => onViewportChange(matches));
}
